import { Modal, Text, CloseButton } from "@mantine/core";
import { FC } from "react";

import { useStyles } from "./SystemUpgradeModal.styles";

interface IProps {
  opened: boolean;
  onClose: () => void;
}

const SystemUpgradeModal: FC<IProps> = ({ opened, onClose }) => {
  const { classes } = useStyles();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      size="md"
      transitionProps={{ duration: 200 }}
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
    >
      <div className={classes.container}>
        <div className={classes.header}>
          <Text className={classes.title}>Merchant Portal System Upgrade</Text>
          <CloseButton onClick={onClose} size="lg" />
        </div>
        <div className={classes.content}>
          <Text className={classes.message}>
            The Merchant Portal is currently undergoing a system upgrade. Please contact your Client
            Success Consultant to submit your collaboration proposal.
          </Text>
          <Text className={classes.thankYou}>Thank you for your understanding.</Text>
        </div>
      </div>
    </Modal>
  );
};

export default SystemUpgradeModal;
